// extracted by mini-css-extract-plugin
export default {"spacer":"root_spacer__fVfpx"};